import { layerAction } from '../reducers/layer';
import Api from './api';
export var addCart = function (_a) {
    var count = _a.count, userInfo = _a.userInfo, idx_b_manager = _a.idx_b_manager, item_id = _a.item_id, opt = _a.opt, dispatch = _a.dispatch, stdpcData = _a.stdpcData, stdpcType = _a.stdpcType, stdpcType2 = _a.stdpcType2, stdpcType3 = _a.stdpcType3, stdpcType4 = _a.stdpcType4;
    if (!userInfo) {
        dispatch(layerAction({
            name: 'login',
        }));
        return;
    }
    if (!opt) {
        dispatch(layerAction({
            // 미리 장바구니 담기 성공 레이어 띄움
            name: 'cart',
        }));
    }
    var itemList = [];
    if (!stdpcData || stdpcData.length === 0) {
        itemList.push({
            itemID: item_id,
            count: count,
        });
    }
    else {
        itemList.push({
            itemID: item_id,
            count: count,
            stdpc_item_list: stdpcData,
            stdpcType: stdpcType,
            stdpc_item_list_type1: stdpcType,
            stdpc_item_list_type2: stdpcType2,
            stdpc_item_list_type3: stdpcType3,
            stdpc_item_list_type4: stdpcType4
        });
    }
    Api.addCart(idx_b_manager, (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_idx) || null, itemList).then(function (res) {
        // 장바구니 담기 성공
        if (opt) {
            window.open(process.env.REACT_APP_CART_URL);
        }
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/detail/utils/add_cart.ts
// module id = 59
// module chunks = 0